import React from 'react';
import { ISmartProps } from './types';
import { View } from './view';

export type AvatarProps = Omit<ISmartProps, 'css'>;
export const Avatar = React.forwardRef(View);
